export { ErrorState } from './ErrorState';
export type { ErrorStateProps } from './ErrorState';
